import type {
    SeoConfig,
    DefaultSeoConfig,
    OrganizationSeoConfig,
    OrganizationContentSeo,
    OrganizationAddressSeo,
    OrganizationContactPointSeo,
    ProductSeoConfig,
    ProductAttributesSeoConfig,
    ProductImageSeoConfig,
    TagManagerConfig,
    Maybe
} from '@preload/graphql/getConfig.d'
import type { CustomPages } from './seo/customPages'
import { customPages } from './seo/customPages'
import type { CheckoutSteps } from './seo/checkoutSteps'
import { checkoutSteps } from './seo/checkoutSteps'

export enum ItemCondition {
    NEW = 'https://schema.org/NewCondition',
    USED = 'https://schema.org/UsedCondition',
    DAMAGED = 'https://schema.org/DamagedCondition',
    REFURBISHED = 'https://schema.org/RefurbishedCondition'
}

export type FrontendSeoConfig = SeoConfig & {
    default: DefaultSeoConfig & {
        title: string
    }
    product: ProductSeoConfig & {
        attributes: ProductAttributesSeoConfig
        image: ProductImageSeoConfig & {
            count: number
            width: number
        }
    }
    organization?: OrganizationSeoConfig & {
        content: OrganizationContentSeo & {
            '@context': string
            '@type': string
            address?: OrganizationAddressSeo & {
                '@type': string
            }
            contactPoint?: Array<
                Maybe<OrganizationContactPointSeo & { '@type'?: string }>
            >
            legalname?: Maybe<string>
            description?: Maybe<string>
        }
    }
    customPages: CustomPages
    checkoutSteps: CheckoutSteps
    tagManager: TagManagerConfig
    multiStoreUrlParamCount?: number
}

export const seo: FrontendSeoConfig = {
    default: {
        title: ''
    },
    product: {
        attributes: {},
        image: {
            count: 1,
            width: 620
        }
    },
    organization: {
        content: {
            '@context': 'https://schema.org',
            '@type': 'Corporation',
            legalname: 'Casaideas',
            url: 'https://casaideas.cl/',
            logo: 'https://casaideas.cl/media/logo/stores/1/logo_casaideas_4x.png',
            email: 'serviciocliente@casaideas.com',
            description:
                'En Casaideas queremos alegrar y facilitar la vida de las personas con productos sustentables que sorprenden e inspiran. Pensando en los apasionados por la casa, hemos creado una amplia oferta de productos accesibles con diseño propio que buscan brindar belleza y funcionalidad en cada espacio del hogar',
            address: {
                '@type': 'PostalAddress',
                postalCode: '8330291',
                streetAddress: 'Manuel Antonio Tocornal 356',
                addressCountry: 'Chile',
                addressRegion: 'Región Metropolitana',
                addressLocality: 'Santiago'
            },
            sameAs: [
                'https://www.pinterest.cl/Casaideas_',
                'https://www.instagram.com/casaideaschile',
                'https://www.facebook.com/CasaideasChile'
            ],
            knowsLanguage: 'SP'
        }
    },
    customPages,
    checkoutSteps,
    tagManager: {},
    multiStoreUrlParamCount: 0
}

export default seo
